import { Pipe, PipeTransform } from "@angular/core";
import { Datum, isPending } from "@nll/datum/Datum";

@Pipe({
  name: "isDatumPending",
  standalone: false,
})
export class IsDatumPendingPipe implements PipeTransform {
  transform(datum: Datum<unknown> | undefined | null) {
    return isPending(datum);
  }
}
